import type { AgoraParticipantLike } from '../types';

/** `room.localParticipant` is rebuilt each access; use uid (not reference) for equality. */
export function sameAgoraParticipant(
  a: AgoraParticipantLike | null | undefined,
  b: AgoraParticipantLike | null | undefined
): boolean {
  if (!a || !b) return false;
  return a.uid === b.uid;
}
